
import { Component, Vue ,Watch} from "vue-property-decorator";

import { IDefaultShippingOrderModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { Message } from "element-ui";
// import { cloneDeep } from "lodash";
import { ShippingOrderModel } from "@/model/shipping-order";
// 查看产品系统弹窗
import ProductSystem from "./cpns/details.vue";
// 新建/编辑表单
import NewBuild from "./cpns/newBuild.vue";
import {
  deleteProduct,
  disabledProduct,
  searchProducts,
  uploadProduct,
  uploadProductPerformanceTarget,
} from "@/api/product-business";
import { getProduct } from "@/api/product-category";
import { Product } from "@/model/productCategory";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import BaseUcenterTable from "@/components/BaseTable/index.vue";
import BaseTable from "@/components/BaseTable/index.vue";
import { getProductManagerUser } from "@/api/users";
import { searchCustomer ,queryTheNumberBilInfo,getnotDeleteNumber,deleteModelNumber} from "@/api/customer";
@Component({
  name: "productCategoryManagement",
  components: {
    BaseTable,
    BaseUcenterTable,
    Pagination,
    ProductSystem,
    NewBuild,
  },
})
export default class extends Vue {
  public dialogVisible: Boolean = false;
  public notDeleteModelInfo:Boolean = false;
  public serachBtn: Boolean = false;
  public visible:Boolean = false;
  public notDeleteNumberBtn: Boolean = false;
  public productInfo = {}
  private productList: ProductTable[] = [];
  public current: Product = new Product();
  public disabled: Boolean = true;
  async editProduct(productId: string, params: string, type: string) {
    const data: any = await getProduct(productId);
    this.current = data;
    this.dialogShow(params, type);
  }
  public toNumberManager(row) {
    this.$router.push({
      name: "ProductNumberManagement",
      query: {
        id: row.id,
        name: row.productName,
        productId: row.productId,
        sn: row.sn,
      },
    });
  }
  public notDeleteModel:Array<any> = [
    {
      label: "SN",
      prop: "pnNumber",
    },
    {
      label: "号码类型",
      prop: "numberType",
    },
    {
      label: "号码",
      prop: "number",
    }
  ]
  public notDeleteModelData:Array<any> = []
  public column: Array<any> = [
    {
      label: "单据号码",
      prop: "code",
    },
    {
      label: "SN",
      prop: "pnNumber",
    },
    {
      label: "单据中的SN",
      prop: "sn",
    },
    {
      label: "号码类型",
      prop: "numberType",
    },
    {
      label: "号码",
      prop: "number",
    },
    {
      label: "生成时间",
      prop: "time",
    }
  ];
  public tableData = [[]];
  public formItem: Array<any> = [
    {
      label: "客人",
      type: "select",
      prop: "customerId",
      key:"customerId",
      value: "",
      placeholder: "请输入客人姓名",
      options: [],
      remote: true,
      remote_method: this.getGuestList,
      clearable: true,
    },
    {
      label: "华强品名",
      type: "input",
      prop: "hqProductName",
      key:"hqProductName",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "号码",
      type: "input",
      prop: "number",
      key:"number",
      value: "",
      placeholder: "请输入号码",
    },
  ];
  public changeValue(values: any) {
    const key = values.key 
    const value = values.value 
    this.productInfo = Object.assign(this.productInfo, {
      [key]:value
    });
    this.notDeleteNumberBtn = false
    this.serachBtn = false
  }
  public async search(e:any){
    this.serachBtn = true;
    const res:any = await queryTheNumberBilInfo(e)
    const classifiedArray = res.reduce((acc, obj) => {
    // 如果 source 不为 null，则进行分类
    if (obj.source !== null) {
        // 如果分类不存在，则初始化为空数组
        if (!acc[obj.source]) {
            acc[obj.source] = [];
        }
        // 将对象添加到相应的分类中
        acc[obj.source].push(obj);
    }
    return acc;
    }, {});
    this.tableData =Object.values(classifiedArray);
  }
  public async getGuestList(keyword?: any) {
    const res: any = await searchCustomer({ keyword: keyword });
    this.formItem.find(e => e.key === 'customerId').options = res.map((item: any) => {
      return {
        ...item,
        // name: item.code,
        name: item.abbreviation,
      };
    });
  }
  private getCustomerLoading = false;
  private customerList = [] as any;
  private async getCustomer(name = "") {
    this.getCustomerLoading = true;
    await searchCustomer({ keyword: name }).then((res:any) => {
      this.customerList = res;
      this.getCustomerLoading = false;
    }).catch(err => {
      console.log(err);
      this.getCustomerLoading = false;
    });
    // this.searchForm[1].options = res;
  }
  public async deleteNumber(){
    await deleteModelNumber(this.productInfo).then(res => {
      this.dialogVisible = false
      this.visible = false
      this.tableData = [[]]
      this.$message({
        type: "success",
        message: "操作成功!",
      });
    }).catch(err => {
      console.log(err)
    })
  }
  public async notDeleteNumber(){
    this.notDeleteNumberBtn = true
    try {
      const res:any = await getnotDeleteNumber(this.productInfo)
      this.notDeleteModelData = res
      this.notDeleteModelInfo = true
    } catch (error) {
      console.log(error);
    }    
  }
  private exportExcel() {
    const data = this.productList.map((value) => {
      return {
        // packingState: value.state.desc,
        // grossWeight: value.packingWeight.grossWeight,
        // netWeight: value.packingWeight.netWeight,
        ...value,
      };
    });
    const headers = [
      "华强品名",
      "产品经理",
      "产品系统",
      "型号数量",
      "SKU数量",
      "绩效目标",
      "当前绩效",
    ];
    const fieldNames = [
      "productName",
      "managerId",
      "productCategory",
      "modelQuantity",
      "skuQuantity",
      "performanceGoals",
      "currentPerformance",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `产品层级管理-${new Date()}`
    );
  }

  private files: File[] = [];

  // 点击显示弹窗
  public dialogShow(params: string, type: string) {
    this.$refs[params]["type"] = type || "";
    this.$refs[params]["dialogVisible"] = true;
  }

  public productManagerList = [];
  public active_name = "1";
  private tableKey = 0;
  public shippingOrder: IDefaultShippingOrderModel[] = [];

  private total = 0;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  private listParam = {
    productManagerId: null,
    type: "FLAGSHIP",
    productCategoryId: null,
    productName: null,
    pageNumber: 1,
    pageSize: 20,
    // customerId: null
  };

  created() {
    this.getGuestList(null);
    this.getList();
    getProductManagerUser().then((res: any) => {
      this.productManagerList = res;
    });
  }
  private canEdit(row: any) {
    let text = "彩盒彩带中性包装汽车配件";
    if (text.indexOf(row.productCategory) > -1) {
      return false;
    }
    return true;
  }

  private handleFilter() {
    this.listParam.pageNumber = 1;
    this.getList();
  }

  private gotoProductSystemManagement() {
    this.$router.push("/productSystemManagement");
  }

  private loading = false; // table的loading控制
  private async getList() {
    this.loading = true;
    const params = { ...this.listParam };
    await searchProducts(params).then((data:any) => {
      this.productList = data.list;
      this.total = +data.total;
      this.listParam.pageNumber = +data.page;
      this.loading = false;
    }).catch(err => {
      console.log(err);
      this.loading = false;
    });
  }

  private async changeDisabledState(row: any) {
    await disabledProduct(row.id).then(() => {
      this.$message({
        type: "success",
        message: "操作成功!",
      });
    });
    this.getList();
  }

  private async removeProduct(row: any) {
    await deleteProduct(row.id).then(() => {
      this.$message({
        type: "success",
        message: "操作成功!",
      });
    });
    this.getList();
  }

  private async tabHandleClick() {
    this.productList = [] as any;
    this.total = 0;
    this.listParam.pageSize =20;
    this.listParam.pageNumber = 1;
    this.getList();
  }

  private addFile(file: File) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload(product: boolean) {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    if (product) {
      await uploadProduct(formData).then(() => {
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success",
          duration: 2000,
        });
      });
    } else {
      await uploadProductPerformanceTarget(formData).then(() => {
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success",
          duration: 2000,
        });
      });
    }
    this.files = [];
    //todo 刷新列表
  }
}

class ProductTable {
  id: string;
  productName: string;
  managerId: string;
  productCategory: string;
  modelQuantity: string;
  skuQuantity: string;
  performanceGoals: string;
  currentPerformance: string;
}
